import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-gas',
  templateUrl: './gas.component.html',
  styleUrls: ['./gas.component.scss']
})
export class GasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
